import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../api/apiSlices/apiSlice';
import header from '../slices/headerSlice'
import entryLineDetail from '../slices/entryLineDetailSlice'
import entrySummary from '../slices/entrySummarySlice'
import reconShipments from '../slices/reconShipmentsSlice';
import createReconShipment from '../slices/createShipmentSlice';
import currentJob from '../slices/currentJobSlice';
import loader from '../slices/loaderSlice';
import statusDetail from '../slices/statusDetailSlice';
const reducer = {
  header,
  entryLineDetail,
  entrySummary,
  reconShipments,
  createReconShipment,
  currentJob,
  statusDetail,
  loader,
  [apiSlice.reducerPath]: apiSlice.reducer,
};
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(apiSlice.middleware)
});
export default store;
